<h2 mat-dialog-title>Change Password</h2>
<div mat-dialog-content [formGroup]="passwordForm">
  <div fxLayout="column">
    <mat-form-field fxFlex="100">
      <mat-label>New Password</mat-label>
      <input matInput formControlName="password" type="password" />
      @if (passwordControl.errors?.characterLimit) {
        <mat-error>
          {{ 'PASSWORD.ERROR.CHARACTERLIMIT' | translate }}
        </mat-error>
      }
      @if (passwordControl.errors?.mustBeNumeric) {
        <mat-error>{{ 'PASSWORD.ERROR.MUSTBENUMERIC' | translate }} </mat-error>
      }
      @if (passwordControl.errors?.invalidSpecialCharacter) {
        <mat-error>
          {{ 'PASSWORD.ERROR.INVALIDSPECIALCHARACTER' | translate }}
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field fxFlex="100">
      <mat-label>Confirm Password</mat-label>
      <input
        matInput
        formControlName="passwordConfirm"
        type="password"
        placeholder="Confirm Password"
      />
      @if (passwordConfirmControl.errors?.notMatch) {
        <mat-error>{{ 'PASSWORD.ERROR.CONFIRMATIONDOESNOTMATCH' | translate }}</mat-error>
      }
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="changePassword()" [disabled]="passwordForm.invalid">
    @if (submitting) {
      <mat-icon>
        <mat-spinner diameter="18"></mat-spinner>
      </mat-icon>
    }
    Submit
  </button>
  <button mat-button mat-dialog-close type="button">Close</button>
</div>
